import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import EmptyObject from "@coworker/apprestructured/src/task-management/types/EmptyObject";
import { CardFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/CardFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragment/LoadingCardFragment";

export type TitleCardFragmentConfigProps = EmptyObject;

type TitleCardFragmentProps = {
  configProps: TitleCardFragmentConfigProps;
  commonProps: CardFragmentCommonProps;
};

function TitleCardFragment({ commonProps }: TitleCardFragmentProps) {
  const { task } = commonProps;
  if (isLoading(task)) {
    return <LoadingCardFragment />;
  }
  return <FixaText textStyle="Heading.XS">{task.title}</FixaText>;
}

export default TitleCardFragment;
